import { render, staticRenderFns } from "./GStatisticsBoxplotSubTableInfoTable.vue?vue&type=template&id=41b78cda&scoped=true&"
import script from "./GStatisticsBoxplotSubTableInfoTable.vue?vue&type=script&lang=ts&"
export * from "./GStatisticsBoxplotSubTableInfoTable.vue?vue&type=script&lang=ts&"
import style0 from "./GStatisticsBoxplotSubTableInfoTable.vue?vue&type=style&index=0&id=41b78cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b78cda",
  null
  
)

export default component.exports